class PlotlyGraph

  @start_graph: (graphs, index) ->
    el = graphs[index]
    $(el).addClass('loading')
    $(el).html('<div class="ajax-status">... loading ...</div>')
    url = $(el).data("json_url")
    return unless url

    $.ajax url,
      dataType: "json",
      success: (data) ->
        $(el).html('')
        $(el).removeClass('loading')
        plotly_data = data['data'] if data
        plotly_layout = data['layout'] if data
        margin_r = $(el).attr("data-margin_right")
        Plotly.newPlot($(el).attr('id'), plotly_data, plotly_layout)
        PlotlyGraph.start_graph(graphs, index + 1)
      error: (jqXHR, textStatus, errorThrown) ->
        console.log("Plotly error: " + errorThrown)

module.exports = PlotlyGraph
